// libraries
import React from 'react'

// svg
import { UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'

interface Props {
	tag?: string
	title: string
	content?: string
	img?: {
		src: string
		srcMobile: string
		alt: string
	}
	cta?: {
		text: string
		link: string
		external?: boolean
		hasArrow?: boolean
	}
}

export default function TextCard(props: Props) {

	const {
		tag,
		title,
		content,
		img,
		cta
	} = props

	return (
		<>
			<div className='text-card'>
				<div className='grid-container'>
					<div className='grid-row'>
							
						<div className='image c-md-6 c-lg-5'>
							{img && (
								<figure>
								
									<picture>
										<source media='(min-width: 768px)' srcSet={img?.src} />
										<source media='(max-width: 767px)' srcSet={img?.srcMobile} />
										<img src={img?.src} alt={img.alt ? img.alt : 'Image'} />
									</picture>
								</figure>
							)}
						</div>

						<div className='c-lg-1'></div>

						<div className='c-md-6 content-wrapper'>
							
							{tag && (
								<div className='tag'>
									{tag}
								</div>
							)}

							{title && (
								<div className='title font-title'>
									{title}
								</div>
							)}

							{content && (
								<div
									className='content rich-text'
									dangerouslySetInnerHTML={{ __html: content }}
								/>
							)}

							{cta && (
								<a 
									href={cta.link}
									className='cta'
									target={cta.external ? '_blank' : '_self'}
								>
									
									{cta.text}

									<span className='cta__icon'>
										<UxArrowRight />
									</span>

								</a>
							)}

						</div>

					</div>
				</div>
			</div>
		</>
   )
}